import { getApollo } from '@lib/apollo/apolloClient';
import { gql } from '@apollo/client';

const PRISMIC_SINGLE_DOC_QUERY = gql`
  query PrismicSingleDocument(
    $key: String!
    $previewRef: String
    $graphQuery: String
  ) {
    prismicSingleDocument(
      key: $key,
      previewRef: $previewRef
      graphQuery: $graphQuery
    )
  }
`;

export default async function fetchSinglePrismicDocument(
  prismicType: string,
  {
    previewData,
    graphQuery
  }:{
    previewData?: any;
    graphQuery?: string;
  }
): Promise<any> {
  const apolloClient = getApollo({
    cacheEnabled: true
  });

  const res = await apolloClient.query({
    query: PRISMIC_SINGLE_DOC_QUERY,
    variables: {
      key: prismicType,
      previewRef: previewData?.ref,
      graphQuery
    }
  });

  const prismicSingleDocument = res.data?.prismicSingleDocument
    ? JSON.parse(res.data.prismicSingleDocument)
    : null;

  return prismicSingleDocument;
}
